const productBanner = $('.product-banner-popup');

if (productBanner.length) {
  $(document).click((e) => {
    if (!$(e.target).is('.product-banner-popup, .product-banner-popup-link, .product-banner-popup-items, .btn-group')) {
      productBanner.collapse('hide');
    }
  });
}
